export default "__VITE_ASSET__91ba6430__"